var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ApexPieChart',{attrs:{"categories":_vm.categories,"series":_vm.series},on:{"category-selected":_vm.onSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }